const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    barcode: {
      type: 'string',
      title: 'بارکد',
    },
    product_details: {
      type: 'string',
      title: 'توضیحات',
    },
    description: {
      type: 'string',
      title: 'توضیحات بیشتر',
    },
    status: {
      type: 'string',
      title: 'وضعیت',
      default: 'todo',
      oneOf: [
        { const: 'todo', title: 'در حال انجام' },
        { const: 'doing', title: 'در صف بررسی' },
        { const: 'rejected', title: 'رد شده' },
        { const: 'done', title: 'انجام شده' },
      ],
    },
  },
});

export default schema;
